import { useState, useEffect } from 'react'
import { NavLink } from '../../src/common/navigation'
import {
  AppBar,
  Box,
  Button,
  Toolbar,
  Typography,
  Stack,
  Popover,
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material'
import { isDesktop, isTablet } from 'react-device-detect'
import { Image } from 'antd'
import Link from 'next/link'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import LOGO from '../assets/lightmode@2x.png'
import LogoMobile from '../assets/logo_mobile.png'
import SMFooter from '../../src/components/ui/SMFooter'
import SMHomeDialog from '../containers/Home/Dialog'
import SMAppHomeDialog from '../containers/App-Home/Dialog'
import SMDrawerIcon from '../assets/home/home_drawer.png'
import { PORTOAL_LOGIN_LINK, MERCHANT_LOGIN_LINK, ROOT_PATH, GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK, App_Language_key } from '../common/config'
import AppGallery from '../assets/download/download_appgallery.png'
import GooglePlay from '../assets/download/download_googleplay.png'
import AppStore from '../assets/download/download_appstore.png'
import UserIcon from '../assets/home/icon_user.png'
import LanguageIcon from '../assets/home/icon_language.png'
import BMFlag from '../assets/language-flag/bm-flag.svg'
import ENFlag from '../assets/home/home_en.png'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SMAppFooter from '../components/ui/SMAppFooter'
import axios from 'axios'
import { ProductImageUrl } from '../common/url'
import { useTranslation } from 'react-i18next'
import { ScreenWidthPort } from '../ScreenWidthContext'

export type LayoutProps = {
  showFooter?: boolean;
};

export const Home: React.FC<React.PropsWithChildren<LayoutProps>> = (
  props
) => {

  const { children, showFooter = true } = props

  const { t, i18n } = useTranslation()

  // ======================= STATE
  const [productAnchorEl, setProductAnchorEl] = useState<HTMLButtonElement | null>(null)

  const [signInAnchorEl, setSignInAnchorEl] = useState<HTMLButtonElement | null>(null)

  const [languageAnchorEl, setLanguageAnchorEl] = useState<HTMLButtonElement | null>(null)

  const [language, setLanguage] = useState(sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN')

  const [openDrawer, setOpenDrawer] = useState(false)

  // ======================= VARIABLES
  const productOpen = Boolean(productAnchorEl)
  const productId = productOpen ? 'action-popover' : undefined

  const signInOpen = Boolean(signInAnchorEl)
  const signInId = signInOpen ? 'action-popover' : undefined

  const languageOpen = Boolean(languageAnchorEl)
  const languageId = languageOpen ? 'action-popover' : undefined

  const [openAD, setOpenAD] = useState(false)

  const [openAppAD, setOpenAppAD] = useState(false)

  const [productImageUrl, setProductImageUrl] = useState(null)

  const { showDesktopUI } = ScreenWidthPort()

  useEffect(() => {
    ; (async () => {
      // if (sessionStorage.getItem(App_Language_key) === 'ms') {
      //   i18n.changeLanguage('ms')
      // } else {
      //   i18n.changeLanguage('')
      // }
      await fetchProductImage()
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchProductImage = async () => {
      try {
        const response = await axios.get(ProductImageUrl)
        if (response.status === 200) {
          setProductImageUrl(response.data['data']['attributes']['image'])
        }
      } catch (error) {
        
      }
  }

  // ======================= EVENTS
  const onHandleProductClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setProductAnchorEl(event.currentTarget)
  }

  const onHandleProductClose = () => {
    setProductAnchorEl(null)
  }

  const onHandleSignInClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setSignInAnchorEl(event.currentTarget)
  }

  const onHandleSignInClose = () => {
    setSignInAnchorEl(null)
  }

  const onHandleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    setLanguageAnchorEl(event.currentTarget)
  }

  const onHandleLanguageClose = () => {
    setLanguageAnchorEl(null)
  }

  // All Product
  const clickAllProduct = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/product')
  }

  // Motorcycle Financing
  const clickMotorcycleFinancing = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/motorcycle-financing')
  }

  // Personal Loan
  const clickPersonalLoan = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/personal-loan')
  }

  // Motor Insurance and Roadtax
  const clickMotorInsurance = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/motor-vehicle')
  }

  // SHENMA Mobile
  const clickSHENMAMobile = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/mobile-app')
  }

  // How to Pay
  const clickHowToPay = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/repayment-channel')
  }

  // FAQ
  const clickFAQ = () => {
    onHandleProductClose()
    window.location.replace(ROOT_PATH + '/faq')
  }


  // ======================= GooglePlay
  const clickGooglePlay = () => {
    onHandleProductClose()
    window.open(GOOGLE_PLAY_STORE_LINK)
  }

  // ======================= AppStore
  const clickAppStore = () => {
    onHandleProductClose()
    window.open(APP_STORE_LINK)
  }

  // ======================= AppGallery
  const clickAppGallery = () => {
    onHandleProductClose()
    window.open(APP_GALLERY_LINK)
  }

  // merchat login
  const clickMerchantLogin = () => {
    onHandleSignInClose()
    window.open(MERCHANT_LOGIN_LINK)
  }

  // Portal login
  const clickPortalLogin = () => {
    onHandleSignInClose()
    window.open(PORTOAL_LOGIN_LINK)
  }

  // EN
  const clickEN = () => {
    onHandleLanguageClose()
    setLanguage('EN')
    i18n.changeLanguage('en')
    sessionStorage.setItem(App_Language_key, 'en')
    window.location.reload()
    // if (isDesktop) {
    //   onHandleOpenAD()
    // } else {
    //   onHandleOpenAppAD()
    // }
  }

  // BM
  const clickBM = () => {
    onHandleLanguageClose()
    setLanguage('BM')
    i18n.changeLanguage('ms')
    sessionStorage.setItem(App_Language_key, 'ms')
    window.location.reload()
    // if (isDesktop) {
    //   onHandleOpenAD()
    // } else {
    //   onHandleOpenAppAD()
    // }
  }

  // const onHandleOpenAD = () => {
  //   setOpenAD(true)
  // }

  const onHandleCloseAD = () => {
    setOpenAD(false)
  }

  // const onHandleOpenAppAD = () => {
  //   setOpenAppAD(true)
  // }

  const onHandleCloseAppAD = () => {
    setOpenAppAD(false)
  }


  // Product Service
  const onHandleDrawerProduct = (index: number) => {
    setOpenDrawer(false)
    if (index === 2) {
      window.location.replace(ROOT_PATH + '/motorcycle-financing')
    } else if (index === 3) {
      window.location.replace(ROOT_PATH + '/personal-loan')
    } else if (index === 4) {
      window.location.replace(ROOT_PATH + '/motor-vehicle')
    } else if (index === 5) {
      window.location.replace(ROOT_PATH + '/repayment-channel')
    } else if (index === 6) {
      window.location.replace(ROOT_PATH + '/mobile-app')
    } else if (index === 1) {
      window.location.replace(ROOT_PATH + '/product')
    }
  }

  // Other
  const onHandleDrawerOther = (index: number) => {
    setOpenDrawer(false)
    if (index === 1) {
      window.location.replace(ROOT_PATH + '/repayment-channel')
    } else if (index === 2) {
      window.location.replace(ROOT_PATH + '/faq')
    }
  }

  // drawer click
  const onHandleDrawerClick = (path: string) => {
    setOpenDrawer(false)
    window.location.replace(path)
  }


  const useNavigationMenuItems: NavLink[] = [
    {
      key: 'home',
      title: t('t1'),
      path: '/',
    },
    {
      key: 'about-us',
      title: t('t2'),
      path: ROOT_PATH + '/about-us',
    },
    {
      key: 'product',
      title: t('t3'),
      path: ROOT_PATH + '/product',
    },
    {
      key: 'our-dealer',
      title: t('t4'),
      path: ROOT_PATH + '/our-dealer',
    },
    {
      key: 'news',
      title: t('t5'),
      path: ROOT_PATH + '/news',
    },
    {
      key: 'contact-us',
      title: t('t6'),
      path: ROOT_PATH + '/contact-us',
    },
  ]

  const productAndServiceData = [
    {'key': t('t3')},
    {'key': t('t8')},
    {'key': t('t9')},
    {'key': t('t10')},
    {'key': t('t11')},
    {'key': t('t12')},
    {'key': t('t13')}
  ]

  const otherData = [
    t('t14'),
    t('t15'),
    t('t16')
  ]

  const downloadData = [
    GooglePlay,
    AppStore,
    AppGallery
  ]

  // ======================= RENDER FUNCTIONS
  const renderPC = () => {
    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          width: '100%',
          // maxWidth: 1280,
          margin: 'auto',
          height: '100px'
        }}
      >
        <Link
            href={'/'}
          >
            <Box sx={{
              width: '361px',
              height: '100px',
              alignItems: 'center'
            }}>
              <Image src={LOGO} width={361} height={100} alt='' quality={100} preview={false}></Image>
            </Box>
        </Link>
        <Stack direction="row" alignItems="center" justifyContent="start">
          {renderNavigator()}
          {/* Product */}
          <Popover
            id={productId}
            open={productOpen}
            anchorEl={productAnchorEl}
            onClose={onHandleProductClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            sx={{
              '& .MuiPopover-paper': {
                padding: '0px',
                marginTop: '10px',
                marginLeft: '100px',
              },
            }}
            PaperProps={{
              sx: {
                borderRadius: '8px',
                boxShadow: '0px 2px 7px 0px rgba(76, 78, 100, 0.22)',
              },
            }}
          >
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
            }}>
              <Box sx={{
                paddingLeft: '40px',
                paddingTop: '40px',
              }}>
                <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                  {t('t3')}
                </Typography>
                <Box onClick={clickAllProduct} sx={{
                    cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t8')}
                  </Typography>
                </Box>
                <Box onClick={clickMotorcycleFinancing} sx={{
                  cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t9')}
                  </Typography>
                </Box>
                <Box onClick={clickPersonalLoan} sx={{
                  cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t10')}
                  </Typography>
                </Box>
                <Box onClick={clickMotorInsurance} sx={{
                  cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t11')}
                  </Typography>
                </Box>
                <Box onClick={clickSHENMAMobile} sx={{
                  cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t13')}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{
                paddingLeft: '40px',
                paddingTop: '40px',
              }}>
                <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                  {t('t14')}
                </Typography>
                <Box onClick={clickHowToPay} sx={{
                  cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t15')}
                  </Typography>
                </Box>
                <Box onClick={clickFAQ} sx={{
                  cursor: 'pointer'
                }}>
                  <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} marginTop={'20px'}>
                    {t('t16')}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{
                paddingLeft: '40px',
                paddingTop: '40px',
                width: '200px',
              }}>
                <Typography fontSize={16} fontWeight={600} color={'#141F39'} paddingBottom={'20px'}>
                  {t('t17')}
                </Typography>

                <Box onClick={clickGooglePlay} sx={{
                  width: '90px',
                  height: '30px',
                  cursor: 'pointer',
                }}>
                  <Image src={GooglePlay} width={90} height={30} alt='' preview={false}></Image>
                </Box>
                <Box onClick={clickAppStore} sx={{
                  cursor: 'pointer',
                  marginTop: '10px',
                  width: '90px',
                  height: '30px',
                }}>
                  <Image src={AppStore} width={90} height={30} alt='' preview={false}></Image>
                </Box>
                <Box onClick={clickAppGallery} sx={{
                  cursor: 'pointer',
                  marginTop: '10px',
                  width: '90px',
                  height: '30px',
                }}>
                  <Image src={AppGallery} width={90} height={30} alt='' preview={false}></Image>
                </Box>
              </Box>

              <Box sx={{
                marginLeft: '40px',
                width: '230px',
                height: '324px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center'
              }}>
                <div dangerouslySetInnerHTML={{ __html: productImageUrl }} />
              </Box>
            </Box>
          </Popover>
          <Stack
            direction="row"
            alignItems="center"
          >
          <Box sx={{width: '10px'}}></Box>
          <Button
            onClick={onHandleSignInClick}
            sx={{
              width: isDesktop ? '141px' : '125px',
              height: '55px',
              alignItems: 'center',
              border: '1px solid #FBBF23',
              borderRadius: '46px',
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'rgba(251, 191, 35, 0.08)',
              },
            }}>
            <Image src={UserIcon} width={25} height={25} alt='' preview={false}></Image>
            <Typography flexWrap={'nowrap'} fontSize={16} fontWeight={600} color={'#141F39'} paddingLeft={'10px'}>{t('t7')}</Typography>
          </Button>

          <Box sx={{
            paddingLeft: isDesktop ? '20px' : '10px',
            paddingRight: isDesktop ? '10px' : '0px',
          }}>
            <Box sx={{
              width: '1px',
              height: '40px',
              backgroundColor: '#E4E4E4'
            }}></Box>
          </Box>

          <Button
            onClick={onHandleLanguageClick}
            sx={{
              width: '100px',
              height: '55px',
              alignItems: 'center',
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'rgba(251, 191, 35, 0.08)',
              },
            }}>
            <Image src={LanguageIcon} width={25} height={25} alt='' preview={false}></Image>
            <Typography flexWrap={'nowrap'} fontWeight={500} color={'#141F39'} paddingLeft={'10px'}>{language}</Typography>
            <ArrowDropDownIcon style={{ color: '#141F39', }} />
          </Button>
          </Stack>
          <Box sx={{width: isDesktop ? '10px' : '5px'}}></Box>
        </Stack>
        
      </Stack>
    )
  }

  const renderMobile = () => {
    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          width: '100%',
          // maxWidth: 1280,
          margin: 'auto',
        }}
      >
        <Button
          onClick={() => setOpenDrawer(true)}
          sx={{
            paddingLeft: '10px',
            paddingRight: '0px',
            height: '80px',
            minWidth: '32px'
          }}>
          <Image src={SMDrawerIcon} width={32} height={32} alt='' preview={false}></Image>
        </Button>
        <Link
          href={ROOT_PATH}
        >
          <Box sx={{
            maxWidth: '205px',
            height: '80px',
            alignItems: 'center'
          }}>
            <Image src={LogoMobile} color='#FBBF23' height={80} alt='' preview={false}></Image>
          </Box>
        </Link>

        <Box
          onClick={onHandleSignInClick}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
            paddingRight: '6px',
          }}>

          <Button
            onClick={onHandleLanguageClick}
            sx={{
              height: '80px',
              minWidth: '25px'
            }}>
            <Image src={LanguageIcon} width={25} height={25} alt='' preview={false}></Image>
          </Button>

          <Button sx={{
            height: '80px',
            minWidth: '25px'
          }}>
            <Image src={UserIcon} width={25} height={25} alt='' preview={false}></Image>
          </Button>
        </Box>
      </Stack>
    )
  }

  const renderNavigator = () => {
    return (
      <Box
        sx={{
          paddingLeft: '10px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'start'
        }}
      >
        {useNavigationMenuItems.map((item, index) => {
          return <Button
            key={item.key}
            onClick={item.key === 'product' ? (onHandleProductClick) : (() => window.location.replace(item.path))}
            style={{ 
              transition: 'none',
              transform: 'scale(1)',
            }}
            sx={{
              paddingLeft: '14px',
              paddingRight: '14px',
              borderRadius: '8px',
              height: '55px',
              textTransform: 'none',
              '&:hover': {
                bgcolor: 'rgba(251, 191, 35, 0.08)',
              },
            }}>
            <Typography
              flexWrap={'nowrap'}
              fontWeight={600}
              color={'#141F39'}
              style={{ 
                transition: 'none',
                transform: 'scale(1)',
              }}
            >
              {item.title}
            </Typography>
            {item.key === 'product' && <ArrowDropDownIcon style={{ color: '#141F39', }} />}
          </Button>
        }
        )}
      </Box>
    )
  }

  const renderFooter = () => {
    if (showDesktopUI) {
      return (
        showFooter && <SMFooter />
      )
    } else {
      return (
        showFooter && <SMAppFooter />
      )
    }

  }

  const renderDrawer = () => {
    return (
      <Box sx={{
        height: '100%',
        width: isTablet ? (window.innerWidth - 200) : (window.innerWidth - 60),
        display: 'flex',
        flexDirection: 'column',
      }}>
        {useNavigationMenuItems.map((item, index) => (
          <Box key={index} sx={{
            paddingTop: '5px',
            paddingBottom: '5px',
            paddingLeft: '16px',
          }}>
            {
              index === 2 ?
                <Accordion
                  disableGutters
                  sx={{
                    border: 'none',
                    boxShadow: 'none',
                    '&.MuiAccordion-root': {
                      mt: 0,
                    },
                    '&::before': {
                      display: 'none',
                    },
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{
                    paddingLeft: '0px',
                    paddingTop: '0px',
                    paddingBottom: '0px',
                  }}>
                    <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                      {item.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignContent: 'start',
                      justifyContent: 'start',
                      alignItems: 'start'
                    }}>
                      {/* Product Service */}
                      {
                        productAndServiceData.map((item, index) => (
                          <Button disabled={index === 0} key={index} style={{ 
                            transition: 'none',
                            transform: 'scale(1)',
                          }} onClick={() => onHandleDrawerProduct(index)} sx={{
                            minHeight: '0px',
                            minWidth: '0px',
                            textTransform: 'none'
                          }}>
                            <Typography fontSize={16} fontWeight={index === 0 ? 600 : 500} color={index === 0 ? '#141F39' : '#6B6B6B'} textAlign={'left'}>
                              {productAndServiceData[index]['key']}
                            </Typography>
                          </Button>
                        ))
                      }

                      {/* Other */}
                      {
                        otherData.map((item, index) => (
                          <Button disabled={index === 0} key={index} onClick={() => onHandleDrawerOther(index)} sx={{
                            minHeight: '0px',
                            minWidth: '0px',
                            textTransform: 'none'
                          }}>
                            <Typography fontSize={16} fontWeight={index === 0 ? 600 : 500} color={index === 0 ? '#141F39' : '#6B6B6B'} textAlign={'left'}>
                              {otherData[index]}
                            </Typography>
                          </Button>
                        ))
                      }

                      {/* download */}
                      <Button disabled={true} sx={{
                        minHeight: '0px',
                        minWidth: '0px',
                        textTransform: 'none'
                      }}>
                        <Typography fontSize={16} fontWeight={600} color={'#141F39'} textAlign={'left'} paddingBottom={'6px'}>
                          {t('t17')}
                        </Typography>
                      </Button>
                      {
                        downloadData.map((item, index) => (
                          <Box key={index} sx={{
                            paddingLeft: '6px',
                            paddingTop: '3px',
                            paddingBottom: '3px',
                          }}>
                            <Image width={127} src={downloadData[index]} alt='' preview={false}></Image>
                          </Box>
                        ))
                      }

                    </Box>
                  </AccordionDetails>
                </Accordion>
                :
                <Button
                  onClick={() => onHandleDrawerClick(item.path)}
                  sx={{
                    paddingLeft: '0px',
                    minWidth: '0px',
                    alignContent: 'start',
                    minHeight: '20px',
                    textTransform: 'none',
                  }}>
                  <Typography fontSize={16} fontWeight={600} color={'#141F39'}>
                    {item.title}
                  </Typography>
                </Button>
            }
          </Box>
        ))}
      </Box>
    )
  }

  return (
    <Box>
      <AppBar
        position="sticky"
        sx={{
          color: 'primary.main',
          bgcolor: showDesktopUI ? 'white' : '#FBBF23',
          boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.10)',
        }}
      >
        <Toolbar
          sx={{
            px: 4,
          }}
          style={{
            paddingLeft: 0,
            paddingRight: 0
          }}
        >
          {showDesktopUI ? renderPC() : renderMobile()}
        </Toolbar>
      </AppBar>
      {children}
      {renderFooter()}
      <SMHomeDialog open={openAD} onClose={onHandleCloseAD}></SMHomeDialog>
      <SMAppHomeDialog open={openAppAD} onClose={onHandleCloseAppAD}></SMAppHomeDialog>
      <Drawer anchor={'left'} open={openDrawer} onClose={() => setOpenDrawer(false)}>
        {renderDrawer()}
      </Drawer>
      {/* Sign In */}
      <Popover
        id={signInId}
        open={signInOpen}
        anchorEl={signInAnchorEl}
        onClose={onHandleSignInClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          marginTop: '20px',
          '& .MuiPopover-paper': {
            padding: '0px',
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0px 2px 7px 0px rgba(76, 78, 100, 0.22)',
          },
        }}
      >
        <Box sx={{
          paddingTop: '10px',
          paddingBottom: '10px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignContent: 'start',
        }}>
          <Button
            onClick={clickMerchantLogin}
            sx={{
              paddingLeft: '20px',
              paddingRight: '20px',
              alignContent: 'start',
              justifyContent: 'start',
              textTransform: 'none',
            }}>
            <Typography fontSize={16} fontWeight={500} color={'#141F39'} textAlign={'left'}>
              {t('t438')}
            </Typography>
          </Button>
          <Button
            onClick={clickPortalLogin}
            sx={{
              paddingLeft: '20px',
              paddingRight: '20px',
              alignContent: 'start',
              justifyContent: 'start',
              textTransform: 'none',
            }}>
            <Typography fontSize={16} fontWeight={500} color={'#141F39'}  textAlign={'left'}>
              {t('t439')}
            </Typography>
          </Button>
        </Box>
      </Popover>

      {/* Language */}
      <Popover
        id={languageId}
        open={languageOpen}
        anchorEl={languageAnchorEl}
        onClose={onHandleLanguageClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          marginTop: '20px',
          '& .MuiPopover-paper': {
            padding: '0px',
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0px 2px 7px 0px rgba(76, 78, 100, 0.22)',
          },
        }}
      >
        <Box sx={{
          paddingTop: '20px',
          paddingBottom: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
        }}>
          <Button
            onClick={clickEN}
            sx={{
              paddingLeft: '20px',
              paddingRight: '20px',
            }}>
            <Stack direction="row" alignItems="center" sx={{ gap: 1 }}>
              <Image alt="en" src={ENFlag} width={32} height={32} preview={false} />
              <Typography variant="body2" fontWeight={500} color={'#141F39'}>
                EN
              </Typography>
            </Stack>
          </Button>
          <Button
            onClick={clickBM}
            sx={{
              paddingLeft: '20px',
              paddingRight: '20px',
            }}>
            <Stack direction="row" alignItems="center" sx={{ gap: 1 }}>
              <Image alt="bm" src={BMFlag} width={32} height={32} preview={false} />
              <Typography variant="body2" fontWeight={500} color={'#141F39'}>
                BM
              </Typography>
            </Stack>
          </Button>
        </Box>
      </Popover>
    </Box>
  )
}
